/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import '@/assets/scss/global.scss';
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import 'nprogress/nprogress.css'

import router             from '@/router'
import store              from '@/store'
import { createVuetify }  from 'vuetify'
import * as components    from 'vuetify/components'
import * as directives    from 'vuetify/directives'
import ToastPlugin        from 'vue-toast-notification';
import VueSweetalert2     from 'vue-sweetalert2';
import * as helpers       from "@/plugins/helpers";
import http               from "@/plugins/http";
import VueApexCharts      from "vue3-apexcharts"

const vuetify = createVuetify({

  theme: {
    defaultTheme: localStorage.getItem('__themeMode') || 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#2563EB',
          secondary: '#0F172A',
          accent: '#06B6D4',
          background: '#ededed',
          surface: '#FFFFFF',
          success: '#22C55E',
          warning: '#F59E0B',
          error: '#EF4444',
          info: '#0EA5E9',
          border: '#E2E8F0',
          bgGrey: '#CCCCCC',
          bgWhite: '#fff',
        }
      },
      dark: {
        dark: true,
        colors: {
          primary: '#2563EB',
          secondary: '#FFFFFF',
          accent: '#06B6D4',
          background: '#0F172A',
          surface: '#1E293B',
          success: '#22C55E',
          warning: '#F59E0B',
          error: '#EF4444',
          info: '#0EA5E9',
          border: '#334155',
          bgGrey: '#000000',
          bgWhite: '#0F172A',
        }
      }
    }
  },
  components,
  directives
})
export function registerPlugins (app) {
  app.use(vuetify).use(router).use(store).use(ToastPlugin).use(VueSweetalert2).use(VueApexCharts)
  app.config.globalProperties.$helpers = helpers;
  app.config.globalProperties.$http = http;
}
